<template>
  <!-- <div
    class="status-box  spaceLeft"
    :class="{
      ing: +statusRearly == 1,
      success: +statusRearly == 2,
      failed: +statusRearly == 3
    }"
  >
    <i class="iconfont trn-ing" />
    {{ statusMap["status_"+statusRearly] }}
  </div> -->
  <div>
    <span class="status ing" v-if="[0, 1].includes(this.status)">
      <img src="@/assets/image/governance/icon1.png" alt="">Ongoing
    </span>
    <span class="status passed" v-if="[4, 5, 7, 8].includes(this.status)">
      <img src="@/assets/image/governance/icon2.png" alt="">Passed
    </span>
    <span class="status failed" v-if="[2, 3, 6].includes(this.status)">
      <img src="@/assets/image/governance/icon3.png" alt="">Failed
    </span>
  </div>
</template>

<script>
export default {
  props: {
    status: {
      type: [String, Number],
      default: () => {
        return 1;
      }
    },
    over: {
      type: [Number, String]
    },
    cumulative: {
      type: [Number, String]
    },
    threshold: {
      type: [Number, String]
    }
  },
  data() {
    return {
      statusMap: this.$store.getters.voteStatusMap
    };
  },
  computed: {
    statusRearly() {
      let now = parseInt(new Date().getTime() / 1000);
      let cum = new this.BigNumber(this.cumulative);
      let th = new this.BigNumber(this.threshold);
      if (this.over <= now && cum.comparedTo(th) < 0 && this.status == 1) {
        return 3;
      } else if (this.status == 2) {
        return 2;
      } else if (this.over > now && this.status == 1) {
        return 1;
      } else {
        return 3;
      }
    }
  },
  methods: {},
  created() { },
  watch: {}
};
</script>
<style scoped lang="scss">
// .status-box {
//   padding: 0.04rem 0.04rem 0.04rem 0.1rem;
//   border-radius: 0.04rem;
//   background: rgba(146, 157, 173, 0.1);
//   white-space: nowrap;
//   flex-wrap: nowrap;
//   font-size: 0.15rem;
//   color: #1F1F1F;

//   .iconfont {
//     font-size: 0.24rem !important;
//     margin-right: 0.06rem;
//   }

//   &.ing {
//     background: #DCF0E9;

//     .iconfont {
//       color: #48D5A4;
//     }
//   }

//   &.success {
//     background: #E1E7F5;

//     .iconfont {
//       color: #3172FD;
//     }
//   }

//   &.failed {
//     background: #EBECED;

//     .iconfont {
//       color: #929DAD;
//     }
//   }
// }
.status {
  width: 1.12rem;
  height: 0.28rem;
  display: flex;
  align-items: center;
  color: #1F1F1F;
  font-size: 0.14rem;
  border-radius: 0.04rem;
  line-height: 0.28rem;

  img {
    width: 0.24rem;
    margin-right: 0.06rem;
    margin-left: 0.1rem;
  }
}

.status.ing {
  background: rgba(0,199,131,0.2);
  color: #00C783;
}

.status.passed {
  background: rgba(49, 114, 253, 0.2);
  color: #3172FD;
}

.status.failed {
  background: rgba(146, 157, 173, 0.2);
  color: #929DAD;
}
</style>
